<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Number -->
    <apartment-number-field
      v-model="$attrs.apartment.number"
      :error="$attrs.errors.apartment.number"
    />

    <!-- Customer -->
    <block-field
      v-model="$attrs.apartment.block"
      :error="$attrs.errors.apartment.block"
      v-show="!(formType == 'add' && $attrs.apartment.block)"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import apartmentNumberField from '@/components/forms/apartment/fields/ApartmentNumber'
import blockField from '@/components/forms/apartment/fields/Block'

export default {
  name: 'apartment-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    apartmentNumberField,
    blockField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ApartmentBlankForm.vue?ce346fae